/**
 * What a portal slot (`PortalPlace`) exposes to whatever is portalled into it:
 * the GA `component_index` of the block the slot sits next to. The widget is
 * mounted by owners that do not know their block (one is the page's own
 * filter, which is not a block at all), so it reads the position back from the
 * slot it landed in.
 */
export const SLOT_COMPONENT_INDEX_ATTR = 'data-component-index';

/** The index of the slot `element` sits in, or '' outside any slot. */
export function readSlotComponentIndex(element: Element | null): string {
  return (
    element
      ?.closest(`[${SLOT_COMPONENT_INDEX_ATTR}]`)
      ?.getAttribute(SLOT_COMPONENT_INDEX_ATTR) ?? ''
  );
}
